import theme from '@styles/theme';
export default {
  mobileBottomPanel: (mobile, isVisible) => ({
    display: mobile ? 'block' : 'none',
    padding: '12px 30px 24px',
    background: '#fff',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme.zIndex.documentHigh,
    borderTop: '1px solid #CCCCCC',
    transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
    transition: 'transform .2s linear'
  }),
  productsCount: {
    width: '100%',
    justifyContent: 'center',
    fontWeight: 400
  },
  panelButtons: {
    display: 'block',
    '.a-voxButton': {
      height: '36px'
    }
  }
};